import {
  CreateAccountMessage,
  VerifyClientMessage,
  ChangePasswordMessage,
  ResetPasswordMessage,
  GetDocumentMessage
} from 'storage/user/user.model';

export enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE'
}

export interface SendRequestParams<T> {
  endpoint: string;
  payload?: T | Partial<T>;
  method: RequestMethod;
}

export enum ErrorsTag {
  Modal = 'cos-poszlo-nie-tak',
  NotFound = 'nie-znaleziono-strony',
  BadRequest = 'strona-bledu',
  Unauthorized = 'brak-autoryzacji',
  Forbidden = 'blokada-konta'
}

export type ResponseData<D> = {
  [key: string]: D | boolean | undefined;
  success?: boolean;
};

export type MessagesType = CreateAccountMessage &
  VerifyClientMessage &
  ChangePasswordMessage &
  ResetPasswordMessage &
  GetDocumentMessage;

export const messages = [
  ...Object.values(CreateAccountMessage),
  ...Object.values(VerifyClientMessage),
  ...Object.values(ChangePasswordMessage),
  ...Object.values(ResetPasswordMessage),
  ...Object.values(GetDocumentMessage)
];
